// extracted by mini-css-extract-plugin
export var cardHeader = "_g2-0";
export var reorderHandle = "_g2-3";
export var titleArea = "_g2-1";
export var titleAreaWithHandle = "_g2-2";